var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"dashboard-box margin-top-0"},[_c('div',{},[_c('iframe',{staticClass:"iframe_space",staticStyle:{"width":"100%","height":"800px"},attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}),(_vm.isIframeLoading)?_c('Loader'):_vm._e()],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }